document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    // Custom modal / id="modal360view" fix
    var modal = document.getElementById('modal360view');
    if (modal) {
        modal.addEventListener('show.bs.modal', function (event) {
            var iframe = modal.querySelector('iframe');

            if (iframe && !iframe.src) {
                iframe.src = iframe.getAttribute('data-src');
            }
        });
    }
});
